(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ebc-product-details"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const placeReviewsAfterDetails = () => {
      const detailsSection = document.querySelector('.shopify-section--ebc-product-details');
      const reviews = document.querySelector('#trustoo-widget-wrapper');

      if (!detailsSection || !reviews || detailsSection.nextElementSibling === reviews) {
        return false;
      }

      detailsSection.after(reviews);
      return true;
    };

    if (!placeReviewsAfterDetails()) {
      const observer = new MutationObserver(() => {
        placeReviewsAfterDetails();
      });

      observer.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(() => observer.disconnect(), 15000);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
